import { useEffect, useState } from 'react';
import { useWoodpeckerAuth } from '../woodpecker/Woodpecker';
import { openingRequest } from './api';

export default function useOpeningSet(setId) {
  const auth = useWoodpeckerAuth();
  const { idToken, authProvider, isAuthenticated } = auth;
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [reloadCount, setReloadCount] = useState(0);
  useEffect(() => {
    let active = true;
    setData(null);
    setError('');
    if (isAuthenticated && setId) {
      openingRequest(`/${setId}`, { idToken, authProvider })
        .then(result => { if (active) setData(result); })
        .catch(error => { if (active) setError(error.message); });
    }
    return () => { active = false; };
  }, [setId, idToken, authProvider, isAuthenticated, reloadCount]);
  return { auth, data, error, reload: () => setReloadCount(value => value + 1) };
}
